<template>

  <v-row v-if="!$apollo.loading">
    <v-col cols="2" offset-md="1">
      <v-form ref="form">
      <h1>Crear Torneo</h1>
      <v-text-field label="Título" v-model="tournament.title" :rules="nameRules"></v-text-field>
      <v-text-field label="Direccion" v-model="tournament.address" :rules="nameRules"></v-text-field>
      <v-text-field label="Ciudad" v-model="tournament.city" :rules="nameRules"></v-text-field>
      <v-text-field label="Ritmo" v-model="tournament.time_control" :rules="nameRules"></v-text-field>
      <v-text-field label="Rondas" v-model="tournament.rounds" :rules="numberRules"></v-text-field>
        <v-checkbox v-model="tournament.elo_n" label="Valido Elo N"></v-checkbox>
        <v-checkbox v-model="tournament.elo_int" label="Valido Elo Fide"></v-checkbox>
      <v-select
          v-model="tournament.club_id"
          :items="club"
          label="Selecciona Club"
          :rules="numberRules"
        >

      </v-select>
      <v-text-field label="Categoria" v-model="tournament.category" :rules="nameRules"></v-text-field>
      <v-select
          v-model="tournament.type"
          :items="options"
          label="Selecciona Tipo"
           :rules="nameRules"
        ></v-select>
          <v-text-field label="Ingrese Fecha Inicio dd/mm/YYYY" v-model="tournament.start_date" :rules="dateRules"></v-text-field>
      <v-text-field label="Ingrese Fecha Fin dd/mm/YYYY" v-model="tournament.end_date"></v-text-field>
      <v-text-field label="Capacidad" v-model="tournament.max_inscriptions" :rules="numberRulesNR"></v-text-field>
      <v-checkbox v-model="tournament.can_inscription" label="Activar inscripcion"></v-checkbox>
      <v-text-field label="Cupos Online" v-model="tournament.max_inscriptions_online" :rules="numberRulesNR"></v-text-field>
        </v-form>
    </v-col>

    <v-col cols="8">
      <news-new v-model:value="example_value" ref="new_data"></news-new>
      <v-btn @click="guardar" color="primary">Guardar</v-btn>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios';
import NewsNew from "@/components/news/NewsNew.vue";
import gql from "graphql-tag";
export default {
  props:["id"],
  apollo: {
    data_response: {query: gql` query($id:String!){
       tournament(id:$id){
        id
        title
        address
        type
        content:contentHtml
        start_date:startDateFormated
        end_date:endDateFormated
        club{
          id
        }
        time_control:timeControl
        rounds
        city
        category
        max_inscriptions_online:maxInscriptionsOnline
        max_inscriptions:maxInscriptions
        can_inscription:canInscription
        elo_n:eloN
        elo_int:eloInt
      }
      club {
        value:id
        title:name
      }
    }`,
      variables() {return {"id" :this.id}},
      update(data) {
      if(data.tournament){
        this.tournament = data.tournament;
      }

        this.club = data.club;
    }
    },
  },
    name:"NewsChess",
  data() {
    return {
      options: ["Clasico","Rapido","Blitz"],
      example_value: '<p>Content of the editor.</p>',
      club:[],
      data_response:null,
      tournament: {
        title: '',
        content: '<p>Content of the editor.</p>',
        type: 'Clasico',
        address: '',
        start_date:'',
        end_date:'',
        club_id:'',
        time_control:'',
        rounds:'',
        city:'',
        category:'',
        max_inscriptions_online:'',
        max_inscriptions:'',
        can_inscription:'',
        elo_n:'',
        elo_int:'',
      },
      dateRules: [
      v => !!v || 'La fecha es requerida',
      v => /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/.test(v) || 'La fecha debe estar en formato dd/mm/yyyy',
    ],
        nameRules: [
      v => !!v || 'El campo es requerido',
      v => (/^[A-Za-z0-9\s'+-]+$/).test(v) || 'El campo es inválido',
    ],
      nameRulesNR: [
      v => v === '' || (/^[A-Za-z0-9\s'-]+$/).test(v) || 'El campo es inválido',
    ],
      numberRules: [
      v => !!v || 'El campo es requerido',
      v => (/^[0-9\s'-]+$/).test(v) || 'El campo es inválido debe ser numerico',
    ],
      numberRulesNR: [
      v => (/^[0-9\s'-]+$/).test(v) || 'El campo es inválido debe ser numerico',
    ],
    }
  },
  components: {
    NewsNew
  },
  methods: {
    guardar(){

      this.$refs.form.validate().then(valid => {
        if (valid) {
          const url = '/create_model_tournament/'; // URL de tu endpoint POST

        const data = {
          id : this.id,
          content: this.$refs.new_data.$data.editorData,
          title: this.tournament.title,
          address: this.tournament.address,
          type: this.tournament.type,
          start_date: this.tournament.start_date,
          end_date: this.tournament.end_date,
          time_control: this.tournament.time_control,
          rounds: this.tournament.rounds,
          city: this.tournament.city,
          category: this.tournament.category,
          max_inscriptions_online: this.tournament.max_inscriptions_online,
          max_inscriptions: this.tournament.max_inscriptions,
          can_inscription: this.tournament.can_inscription,
          club_id: this.tournament.club_id,
          elo_n:this.tournament.elo_n,
          elo_int:this.tournament.elo_int,

        };
        axios.post(url, data).then(() => {
          window.location.href = "/mis_torneos"
        })
        .catch(error => {
          alert("datos ingresados no validos")
          console.log(error)
        })
        } else {
          alert("datos ingresados no validos")
        }

        })
    },
    onChange() {
      console.log("this.content",this.content)
    },
    uploadCallback(url) {
      console.log('uploaded url', url)
    },
  },
  watch:{
    '$apollo.loading'(val){
      console.log(val)
      if(!val && this.id){
        console.log("this.tournament",this.tournament)
        this.tournament = JSON.parse(JSON.stringify(this.tournament))
        if(this.tournament.club){
          this.tournament.club_id = this.tournament.club.id
        }
        this.example_value = this.tournament.content
      }
    },
  }
}
</script>
<style>

</style>
